import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IApiResponse,
  IContrato,
  IGetContratosQueryParams,
  IGetContratosUsuarioQueryParams,
  IGetTodosContratosPorGrupoEconomicoQueryParams,
  IListaPaginada
} from 'src/app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class ContratoService {
  private readonly baseURL = '/Contrato';
  constructor(private httpClient: HttpClient) {}

  getContratos(body: IGetContratosQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IContrato>>>(
      this.baseURL,
      body
    );
  }

  getTodosContratosPorGrupoEconomico(
    body: IGetTodosContratosPorGrupoEconomicoQueryParams
  ) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IContrato>>>(
      `${this.baseURL}/ObterTodosContratosPorGrupoEconomico`,
      body
    );
  }

  getContratosUsuario(body: IGetContratosUsuarioQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IContrato>>>(
      `${this.baseURL}/ObterContratosUsuario`,
      body
    );
  }
}
